var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoes = function SvgShoes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_1319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5662 16.2459H23.8257C22.3947 16.2459 21.2242 17.4163 21.2242 18.8474V27.7683C17.3392 28.0486 14.2459 31.3042 14.2459 35.2581V37.4612C14.2459 38.6759 15.2393 39.6693 16.454 39.6693H34.9596C36.1743 39.6693 37.1677 38.6759 37.1677 37.4612V18.8474C37.1677 17.4163 35.9972 16.2459 34.5662 16.2459Z",
    fill: "#2D3336",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0289 18.877H21.4947C20.6826 18.877 20.0243 19.5353 20.0243 20.3474C20.0243 21.1595 20.6826 21.8178 21.4947 21.8178H26.0289C26.841 21.8178 27.4993 21.1595 27.4993 20.3474C27.4993 19.5353 26.841 18.877 26.0289 18.877Z",
    fill: "white",
    stroke: "#2D3336",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0289 22.9685H21.4947C20.6826 22.9685 20.0243 23.6268 20.0243 24.4389C20.0243 25.251 20.6826 25.9093 21.4947 25.9093H26.0289C26.841 25.9093 27.4993 25.251 27.4993 24.4389C27.4993 23.6268 26.841 22.9685 26.0289 22.9685Z",
    fill: "white",
    stroke: "#2D3336",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1526 20.3473H32.4171C30.986 20.3473 29.8156 21.5177 29.8156 22.9488V31.8697C25.9305 32.15 22.8372 35.4055 22.8372 39.3594V41.5626C22.8372 42.7773 23.8306 43.7707 25.0453 43.7707H43.546C44.7607 43.7707 45.7541 42.7773 45.7541 41.5626V22.9488C45.7541 21.5177 44.5837 20.3473 43.1526 20.3473V20.3473Z",
    fill: "#2D3336",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6203 22.9783H30.0861C29.274 22.9783 28.6156 23.6367 28.6156 24.4487C28.6156 25.2608 29.274 25.9192 30.0861 25.9192H34.6203C35.4323 25.9192 36.0907 25.2608 36.0907 24.4487C36.0907 23.6367 35.4323 22.9783 34.6203 22.9783Z",
    fill: "white",
    stroke: "#2D3336",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6203 27.0699H30.0861C29.274 27.0699 28.6156 27.7282 28.6156 28.5403C28.6156 29.3524 29.274 30.0107 30.0861 30.0107H34.6203C35.4323 30.0107 36.0907 29.3524 36.0907 28.5403C36.0907 27.7282 35.4323 27.0699 34.6203 27.0699Z",
    fill: "white",
    stroke: "#2D3336",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_1319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 28.0166,
    fill: "white",
    transform: "translate(14 16)"
  })))));
};
export default SvgShoes;